module.exports = __webpack_public_path__ + "assets/img/szyz-icon.e959cab6.png";